


































import Vue from "vue";
import { State, Action, Mutation } from "vuex-class";
import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";
const namespace = "facebook";

@Component
export default class Campaigns extends Vue {
  @State("facebook") facebook: FacebookState;
  @Action("fetchCampaigns", { namespace }) fetchCampaigns: any;
  @Mutation("selectCampaign", { namespace }) selectCampaign: any;

  handleClick(item: any) {
    this.selectCampaign(item);

    if (!this.facebook.campaignHeadline && !this.facebook.campaignText) {
      const {
        adsets: {
          data: [adset]
        }
      } = this.facebook.selectedCampaigns[0];

      const { message = "", title = "" } =
        adset.ads.data[0].creative?.object_story_spec?.video_data ?? {};
      this.facebook.campaignText = message;
      this.facebook.campaignHeadline = title;
    }
  }

  title = "";
  loading = false;
  headers = [
    { text: "Name", value: "name", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "Daily Budjet", value: "daily_budget", sortable: false },
    { text: "Selected", value: "isSelected", sortable: false }
  ];
  beforeRouteUpdate(to: any, from: any, next: Function) {
    this.fetch({ accountId: to.params.accountId });
    next();
  }
  fetch({ accountId, name }: { accountId: string; name?: string }) {
    this.loading = true;
    this.fetchCampaigns({ accountId, name }).then(() => {
      this.loading = false;
    });
  }
  created() {
    this.fetch({ accountId: this.$route.params.accountId });
  }

  // computed variable based on user's email
}
